__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@rc-d2c/context-manager", "2.6.5", function() { return Promise.all([__webpack_require__.e(6611), __webpack_require__.e(2512)]).then(function() { return function() { return __webpack_require__(2512); }; }); });
			register("next/dynamic", "13.5.7", function() { return Promise.all([__webpack_require__.e(8884), __webpack_require__.e(5339)]).then(function() { return function() { return __webpack_require__(5339); }; }); });
			register("next/head", "13.5.7", function() { return Promise.all([__webpack_require__.e(8884), __webpack_require__.e(966)]).then(function() { return function() { return __webpack_require__(966); }; }); });
			register("next/image", "13.5.7", function() { return Promise.all([__webpack_require__.e(9915), __webpack_require__.e(8884), __webpack_require__.e(2285), __webpack_require__.e(1172)]).then(function() { return function() { return __webpack_require__(9915); }; }); });
			register("next/link", "13.5.7", function() { return Promise.all([__webpack_require__.e(2126), __webpack_require__.e(6456), __webpack_require__.e(8884), __webpack_require__.e(9283)]).then(function() { return function() { return __webpack_require__(6456); }; }); });
			register("next/router", "13.5.7", function() { return Promise.all([__webpack_require__.e(2126), __webpack_require__.e(2455), __webpack_require__.e(661), __webpack_require__.e(8884), __webpack_require__.e(2285), __webpack_require__.e(5286)]).then(function() { return function() { return __webpack_require__(661); }; }); });
			register("next/script", "13.5.7", function() { return Promise.all([__webpack_require__.e(2455), __webpack_require__.e(8884), __webpack_require__.e(2285), __webpack_require__.e(3639)]).then(function() { return function() { return __webpack_require__(3327); }; }); });
			register("react-dom/client", "18.3.1", function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(2285)]).then(function() { return function() { return __webpack_require__(1378); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return __webpack_require__(316); }; }); });
			register("react/jsx-runtime", "18.3.1", function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return __webpack_require__(5723); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(2155); }; }); });
			register("styled-jsx/style", "5.1.1", function() { return Promise.all([__webpack_require__.e(8884), __webpack_require__.e(355)]).then(function() { return function() { return __webpack_require__(355); }; }); });
			register("styled-jsx", "5.1.1", function() { return Promise.all([__webpack_require__.e(8884), __webpack_require__.e(5578)]).then(function() { return function() { return __webpack_require__(5578); }; }); });
			initExternal(5318);
			initExternal(5739);
			initExternal(4503);
			initExternal(2920);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};